var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-submit-drafts",
      attrs: {
        name: "ModalSubmitDrafts",
        width: "30%",
        height: "auto",
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("p", { staticClass: "text-question" }, [
          _vm._v("Are you sure you want to submit your drafts?")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-description" }, [
          _vm._v("You are submitting "),
          _c("b", [_vm._v(_vm._s(_vm.currentEvent.eventName) + ".")]),
          _vm._v(
            "  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted."
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "b-button",
              { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
              [_vm._v("\n        Cancel\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              { staticClass: "btn-submit", on: { click: _vm.onSubmit } },
              [
                _vm.loadingSubmit ? _c("b-spinner") : _vm._e(),
                _vm._v("\n        Submit\n      ")
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae817aca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae817aca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalSubmitDrafts.vue
// module id = 1980
// module chunks = 1